import { render } from "./App.vue?vue&type=template&id=1c4becbc"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=1c4becbc&lang=scss"
script.render = render

export default script